import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Navbar.css";
import logo from "../../assets/images/logo/jayaramlog.png";

const menu = ["Home", "About", "Projects", "Services", "Contact","Career"];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleScroll = (e, section) => {
    e.preventDefault(); // Prevent default anchor behavior

    const id = section.toLowerCase();

    if (location.pathname !== "/") {
      navigate("/");

      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({
          behavior: "smooth",
        });
      }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({
        behavior: "smooth",
      });
    }

    setOpen(false);
  };

  return (
    <header className="navbar">
      <div className="navbar-wrap">

        {/* LEFT */}
        <div className="navbar-left">
          <img src={logo} alt="Jayram InfraCon" />
        </div>

        {/* CENTER */}
        <nav className={`navbar-center ${open ? "open" : ""}`}>
          {menu.map((item, i) => (
            <a
              key={item}
              href="/"
              className={i === 0 ? "active" : ""}
              onClick={(e) => handleScroll(e, item)}
            >
              {item}
            </a>
          ))}
        </nav>

        {/* RIGHT */}
        <div className="navbar-right">
          <div
            className={`hamburger ${open ? "active" : ""}`}
            onClick={() => setOpen(!open)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

      </div>
    </header>
  );
};

export default Navbar;